import { GetStrTotal } from '../Functions/GetStrTotal.js';
import { UCFirst } from '../Functions/UCFirst.js';
import { CreatedAt } from '../Document/CreatedAt.js';
import { BlockLink } from './BlockLink.js';

export const BlockTitleDate1Link1 = (props) => {
    /*
    Pages/Public/Category.js
    Pages/Public/Experiment.js
    Pages/Public/Family.js
    Pages/Public/Origin.js
    Pages/Public/Univers.js
    */
    const { label, items } = props;
    let values; // created, name, author, route, total
    switch (label) {
        case 'category':
        case 'family':
        case 'experiment':
        case 'origin':
        case 'univers':
            if (label === 'category' || label === 'family') {
                values = [
                    { created: items.created, name: UCFirst(items.name), author: items.author },
                    { href: '/categories-et-familles', name: 'Catégories et Familles' },
                    { strTotal: `${items.total} ${GetStrTotal('attraction', items.total)}` },
                ];
            }
            if (label === 'experiment') {
                values = [
                    { created: items.created, name: UCFirst(items.name), author: props.author },
                    { href: '/experiences', name: 'Expériences' },
                    { strTotal: `${items.total} ${GetStrTotal('expérience', items.total)}` },
                ];
            }
            if (label === 'origin') {
                values = [
                    { created: items.created, name: UCFirst(items.oname), author: items.author },
                    { href: '/films-et-series', name: 'Films et Séries' },
                    { strTotal: `${items.total} ${GetStrTotal('attraction', items.total)}` },
                ];
            }
            if (label === 'univers') {
                values = [
                    { created: items.created, name: UCFirst(items.uname), author: items.author },
                    { href: items.proute, name: UCFirst(items.pname) },
                    { strTotal: `${items.total} ${GetStrTotal('attraction', items.total)}` },
                ];
            }
            return (
                <div className="block-title">
                    <CreatedAt date={values[0].created} />
                    <div className="title">
                        <div className="title-name">{values[0].name}</div>
                        <div className="title-total-label">{values[2].strTotal}</div>
                        <div className="title-author">{values[0].author}</div>
                        <BlockLink label="link-true" href={values[1].href} name={values[1].name} />
                    </div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}